import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Select from 'react-select';
import { base_url } from '../../Api/Api';
import PulseLoader from "react-spinners/PulseLoader";
import Popup from '../../Common/Popup';

const ReplayedTicket = (props) => {

    const [state, setState] = useState({
        categorySubject: [],
        imgUrl: '',
        descriptionValue: '',
        validInput: false,
        loader: false,
        popup: false,
        textApi: ''
    })

    useEffect(() => {


        base_url.get(`ticket_categories`)
            .then(response => {
                setState({
                    ...state,
                    categorySubject: response.data.ticketcategories
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, []);

    const loadFile = (event) => {
        var image = document.getElementById('output');
        image.src = URL.createObjectURL(event.target.files[0]);
        setState({
            ...state,
            imgUrl: image.src
        })
    };

    const deletePictuer = () => {
        var image = document.getElementById('output');
        image.src = '';
        setState({
            ...state,
            imgUrl: ''
        })
    }

    const changeInput = (value, taget) => {
        setState({
            ...state,
            [taget]: value
        })
    }

    const submitTicket = () => {
        if (state.descriptionValue.length >= 3) {

            setState({
                ...state,
                loader: true
            })
            if (state.imgUrl.length == 0) {

                const dataWithoutImg = {                    
                    ticket_id: props.match.params.id,
                    message: state.descriptionValue
                };
                base_url.post(`ticket_reply`, dataWithoutImg)
                    .then(resp => {
                        if (resp.data.status == 1) {
                            setState({
                                ...state,
                                popup: true,
                                textApi: 'پیام شما با موفقیت ارسال شد',
                                validInput: false,
                                loader: false,
                                imgUrl: '',
                                descriptionValue: '',
                            })
                        } else {
                            setState({
                                ...state,
                                popup: true,
                                textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                validInput: false,
                                loader: false,
                                imgUrl: '',
                                descriptionValue: '',
                            })
                        }
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            if (error.response.status == 401) {
                                props.history.push(`/Entrance`)
                            }
                        }
                    })
            } else {

                var data = new FormData(document.getElementById("form"));
                base_url.post(`ticket_image`, data)
                    .then(response => {

                        const dataTicket = {
                            ticket_id: props.match.params.id,
                            message: state.descriptionValue,
                            ticketAttach: response.data.ticketAttach
                        };
                        base_url.post(`ticket_reply`, dataTicket)
                            .then(resp => {
                                if (resp.data.status == 1) {
                                    setState({
                                        ...state,
                                        popup: true,
                                        textApi: 'پیام شما با موفقیت ارسال شد',
                                        validInput: false,
                                        loader: false,
                                        imgUrl: '',
                                        descriptionValue: '',
                                    })
                                } else {
                                    setState({
                                        ...state,
                                        popup: true,
                                        textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                        validInput: false,
                                        loader: false,
                                        imgUrl: '',
                                        descriptionValue: '',
                                    })
                                }
                            })
                            .catch(error => {
                                if (error.response != undefined) {
                                    if (error.response.status == 401) {
                                        props.history.push(`/Entrance`)
                                    } else {
                                        setState({
                                            ...state,
                                            popup: true,
                                            textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                            validInput: false,
                                            loader: false,
                                            imgUrl: '',
                                            descriptionValue: '',
                                        })
                                    }
                                }
                            })
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            if (error.response.status == 401) {
                                props.history.push(`/Entrance`)
                            } else {
                                setState({
                                    ...state,
                                    popup: true,
                                    textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                    validInput: false,
                                    loader: false,
                                    imgUrl: '',
                                    descriptionValue: '',
                                })
                            }
                        }
                    })
            }

        } else {
            setState({
                ...state,
                validInput: true
            })
        }
    }

    const closePopup = () => {
        setState({
            ...state,
            popup: false
        })
        props.history.goBack()
    }

    return (
        <div className="newTicket replayed-ticket">
            <Popup
                active={state.popup} >
                <h4>{state.textApi}</h4>
                <Button
                    variant="contained"
                    onClick={closePopup} >تایید</Button>
            </Popup>
            <div className="contain">
                <div className="ticketInfo">
                    <span className="title">ارسال تیکت جدید</span>
                    <div className="form">
                        <div className="input-form">
                            <div className="item-input">
                                <TextField
                                    className="description-input"
                                    label="متن پیام"
                                    multiline
                                    rowsMax={6}
                                    value={state.descriptionValue}
                                    onChange={(e) => changeInput(e.target.value, 'descriptionValue')} />
                                <span className={`error-respns ${state.descriptionValue.length <= 3 && state.validInput ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                                    متن پیام خود کامل وارد کنید
                                </span>
                            </div>
                        </div>
                        <div className="upload">
                            <div className={`pic-ticket ${state.imgUrl.length == 0 ? '' : 'active'}`}>
                                <form className="up" id="form">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        name="ticketAttach"
                                        id="file"
                                        onChange={(event) => loadFile(event)} />
                                    <span> <i className="icon-upload"></i> آپلود عکس</span>
                                </form>
                                <div className="selected-pic">
                                    <img id="output" src="" />
                                    <div className="overlay-delete">
                                        <i className="icon-bin" onClick={deletePictuer}></i>
                                    </div>
                                </div>
                            </div>
                            {state.loader ?
                                <Button
                                    variant="contained" >
                                    <PulseLoader
                                        color="#fff"
                                        loading={state.loading}
                                        size={12} />
                                </Button>
                                :
                                <Button
                                    variant="contained"
                                    onClick={submitTicket} >ارسال</Button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReplayedTicket;